import { render, staticRenderFns } from "./NavBurger.vue?vue&type=template&id=271d3e22"
import script from "./NavBurger.vue?vue&type=script&lang=js"
export * from "./NavBurger.vue?vue&type=script&lang=js"
import style0 from "./NavBurger.vue?vue&type=style&index=0&id=271d3e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports